import axios from 'axios';
import {
  GET_BADGES,
  GET_BADGE,
  ADD_BADGE,
  DELETE_BADGE,
  UPDATE_BADGE,
  BADGES_LOADING,
  BADGE_LOADING,
  CLEAR_CURRENT_BADGE,
  GET_USER_BADGES
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

export const getBadges = () => (dispatch, getState) => {
  dispatch({ type: BADGES_LOADING });
  axios
    .get('/api/badges', tokenConfig(getState))
    .then(res => dispatch({ type: GET_BADGES, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

export const getBadge = (id) => (dispatch, getState) => {
  dispatch({ type: BADGE_LOADING });
  axios
    .get(`/api/badges/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_BADGE, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

export const addBadge = (badge) => (dispatch, getState) => {
  return axios
    .post('/api/badges', badge, tokenConfig(getState))
    .then(res => {
      dispatch({ type: ADD_BADGE, payload: res.data });
      return res.data;
    })
    .catch(err => {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      throw err;
    });
};

export const updateBadge = (id, badge) => (dispatch, getState) => {
  return axios
    .put(`/api/badges/${id}`, badge, tokenConfig(getState))
    .then(res => {
      dispatch({ type: UPDATE_BADGE, payload: res.data });
      return res.data;
    })
    .catch(err => {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      throw err;
    });
};

export const deleteBadge = (id) => (dispatch, getState) => {
  axios
    .delete(`/api/badges/${id}`, tokenConfig(getState))
    .then(() => dispatch({ type: DELETE_BADGE, payload: id }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

export const clearCurrentBadge = () => ({ type: CLEAR_CURRENT_BADGE });

export const getUserBadges = (userId) => (dispatch, getState) => {
  dispatch({ type: BADGES_LOADING });
  axios
    .get(`/api/badges/user/${userId}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_USER_BADGES, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

export const awardBadge = (userId, badgeId) => (dispatch, getState) => {
  return axios
    .post('/api/badges/award', { userId, badgeId }, tokenConfig(getState))
    .then(res => res.data)
    .catch(err => {
      dispatch(returnErrors(err.response?.data, err.response?.status));
      throw err.response?.data || err;
    });
};
